import React from "react";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./presentation/providers/AuthProvider";
import { AppStateProvider } from "./presentation/providers/AppStateProvider";
import { AppRouter } from "./presentation/router/AppRouter";

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppStateProvider>
        <AppRouter />
        <Toaster
          position="bottom-center"
          toastOptions={{
            duration: 4000,
            style: {
              fontFamily: "'Oswald', sans-serif",
              fontSize: "14px",
            },
            error: {
              style: {
                background: "#FFCEA1",
                color: "#000000",
              },
            },
            success: {
              style: {
                background: "#A4FF24",
                color: "#000000",
              },
            },
          }}
        />
      </AppStateProvider>
    </AuthProvider>
  );
};
